import { BehaviorSubject } from "rxjs";

import { ANIMATION_DIRECTION, Step, StepAnimation } from "./types";

class StepperController {
    currentStep$ = new BehaviorSubject<Step | undefined>(undefined);
    stepList$ = new BehaviorSubject<Step[]>([]);
    outAnimation$ = new BehaviorSubject<ANIMATION_DIRECTION>(
        ANIMATION_DIRECTION.NO_ANIMATION
    );
    inAnimation$ = new BehaviorSubject<ANIMATION_DIRECTION>(
        ANIMATION_DIRECTION.NO_ANIMATION
    );

    updateSteps(stepList: Step[]) {
        this.stepList$.next(stepList);
    }

    registerStep(name: string, order: number) {
        const steps = this.stepList$.value;

        const isStepAlreadyExist = steps.find((step) => step.name === name);

        if (isStepAlreadyExist) return;

        if (steps.length === 0) {
            this.currentStep$.next({ name, order });
        }

        this.stepList$.next(
            [...steps, { name, order }].sort((a, b) => a.order - b.order)
        );
    }

    unregisterStep(name: string) {
        this.stepList$.next(
            this.stepList$.value.filter((step) => step.name !== name)
        );
    }

    nextStep() {
        const stepList = this.stepList$.value;
        const currentStep = this.currentStep$.value;

        const currentIndex = stepList.findIndex(
            (step) => step.name === currentStep?.name
        );
        const nextStep =
            currentIndex !== -1 ? stepList[currentIndex + 1] : undefined;

        if (nextStep) {
            this.outAnimation$.next(ANIMATION_DIRECTION.FROM_RIGHT_TO_LEFT);
            this.inAnimation$.next(ANIMATION_DIRECTION.FROM_LEFT_TO_RIGHT);
            this.currentStep$.next(nextStep);
        }
    }

    prevStep() {
        const stepList = this.stepList$.value;
        const currentStep = this.currentStep$.value;

        const currentIndex = stepList.findIndex((step) => step === currentStep);
        const nextStep = currentIndex ? stepList[currentIndex - 1] : undefined;

        if (nextStep) {
            this.outAnimation$.next(ANIMATION_DIRECTION.FROM_LEFT_TO_RIGHT);
            this.inAnimation$.next(ANIMATION_DIRECTION.FROM_RIGHT_TO_LEFT);
            this.currentStep$.next(nextStep);
        }
    }

    goToStep(stepName: string, animation?: StepAnimation) {
        const stepList = this.stepList$.value;
        const step = stepList.find((step) => step.name === stepName);

        if (!step) {
            throw new Error("There are no step found with this name!");
        }

        if (animation) {
            this.outAnimation$.next(animation.outAnimation);
            this.inAnimation$.next(animation.inAnimation);
        }

        this.currentStep$.next(step);
    }

    resetAnimation() {
        this.inAnimation$.next(ANIMATION_DIRECTION.NO_ANIMATION);
        this.outAnimation$.next(ANIMATION_DIRECTION.NO_ANIMATION);
    }

    resetCurrentStep() {
        const stepList = this.stepList$.value;
        this.currentStep$.next(stepList[0] || undefined);
    }
}

export default StepperController;
